// extracted by mini-css-extract-plugin
module.exports = {"itemContentRoot":"DeletedFeedItemTheme__itemContentRoot--i7-47","itemText":"DeletedFeedItemTheme__itemText--1Wna8"};